import { SpaceBackground } from '../types/spaces';
import { FILES_ENDPOINTS } from '../endpoints';

/**
 * Given a SpaceBackground with type 'image', return the URL to use for display.
 *
 * - If the background has a `fileId` (S3-backed), uses FILES_ENDPOINTS.read so the
 *   auth token is always current and no base64 is stored in MongoDB.
 * - Otherwise falls back to `value` directly (legacy data URLs or external URLs).
 */
export function resolveBackgroundImageUrl(background: SpaceBackground): string {
  if (background.type !== 'image') return '';

  if (background.fileId) {
    return FILES_ENDPOINTS.read(background.fileId, undefined, 'full');
  }

  return background.value ?? '';
}
